import axios from "axios";

export const csHttp = axios.create({
  baseURL: process.env.REACT_APP_COURIERSUB_API_BASE, // https://mototaksi.az:8888
  timeout: 20000,
});
